function handleName() {
  console.log('Ready to go!');

  // Listen to name field change and update firstname and lastname fields.
  const nameField = document.querySelector('input[name="name"]');
  const firstNameField = document.querySelector(
    'input[name="user[firstname]"]'
  );
  const lastNameField = document.querySelector('input[name="user[lastname]"]');

  if (nameField && firstNameField && lastNameField) {
    nameField.addEventListener('input', function (e) {
      console.log({ e });
      const name = e.target.value;
      const names = name.split(' ');

      if (names.length) {
        firstNameField.value = names[0];
        names.shift(); // Remove the first name from the array.

        // We remove the first name from the array, so we can join the rest of the names.
        lastNameField.value = names.join(' ');
      }
    });
  }
}

function handlePassword() {
  // password-eye
  const passwordField = document.querySelector('input[name="user[password]"]');
  const passwordEye = document.querySelector('.password-eye');

  passwordEye.addEventListener('click', function (e) {
    if (passwordField.type === 'password') {
      passwordField.type = 'text';
      passwordEye.classList.remove('fa-eye');
      passwordEye.classList.add('fa-eye-slash');
    } else {
      passwordField.type = 'password';
      passwordEye.classList.remove('fa-eye-slash');
      passwordEye.classList.add('fa-eye');
    }
  });
}

if (document.readyState === 'complete') {
  // The page is already loaded before this script runs, which means turbo:load won't trigger on this page load. Trigger it manually.
  // handleName();
  handlePassword();
}
document.addEventListener('turbo:load', function () {
  // This event will be fired every time a page is loaded (after the file is included in the document).
  // handleName();
  handlePassword();
});
